import {AssetLunarPurchaseOptionPostDataTransferObject} from "../../data-transfer-object/asset/AssetLunarPurchaseOptionPostDataTransferObject"
import {AssetLunarPurchaseOptionValueObject} from "../../value-object/asset/AssetLunarPurchaseOptionValueObject"
import {StatePair, useStatePair} from "react-type-extension"
import {DateFormat} from "ts-format-extension"
import {unwrapUndefinedDate, unwrapUndefinedString} from "ts-type-extension"

export type AssetLunarPurchaseOptionPostState = {
    lunarAmount: StatePair<number>
    cashAmount: StatePair<number>
    toDataTransferObject(): AssetLunarPurchaseOptionPostDataTransferObject
    fromValueObject(vo: AssetLunarPurchaseOptionValueObject): void
    values(): [number, number]
}

export function useAssetLunarPurchaseOptionPostState(): AssetLunarPurchaseOptionPostState {
    return {
        lunarAmount: useStatePair<number>(0),
        cashAmount: useStatePair<number>(0),
        toDataTransferObject(): AssetLunarPurchaseOptionPostDataTransferObject {
            return {
                lunarAmount: this.lunarAmount.value,
                cashAmount: this.cashAmount.value,
            }
        },
        fromValueObject(vo: AssetLunarPurchaseOptionValueObject) {
            this.lunarAmount.setter(vo.lunarAmount)
            this.cashAmount.setter(vo.cashAmount)
        },
        values(): [number, number] {
            return [
                this.lunarAmount.value,
                this.cashAmount.value,
            ]
        }
    }
}
